import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { BookingProvider } from './state/BookingContext';
import Layout from './components/Layout';
import BookingPage from './pages/BookingPage';
import ReviewPage from './pages/ReviewPage';
import CheckoutPage from './pages/CheckoutPage';
import ResultPage from './pages/ResultPage';

export default function App() {
  return (
    <BookingProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<BookingPage />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </BookingProvider>
  );
}
